import React, { useEffect, useState } from 'react';
import { IEditVenueProps } from './IEditVenueProps';
import { useNavigate } from 'react-router-dom';
import LabelledInput from '../LabelledInput';
import PrimaryButton from '../PrimaryButton';
import Spinner from '../Spinner';
import ConfirmAlert from '../confirmAlert';
import ErrorAlert from '../ErrorAlert';
import SuccessAlert from '../SuccessAlert';
import WarningAlert from '../WarningAlert';
import { ApiHandler } from '../../services/apiHandler';
import { CloseOutlined, DeleteTwoTone, FileImageOutlined } from '@ant-design/icons';
import LabelledInputNew from '../LabelledInputNew';
import { PenIcon } from '../../custom_icons/PenTool';
import SecondaryButton from '../SecondaryButton';
import LabelLessInput from '../LabelLessInput';
import Dragger from 'antd/es/upload/Dragger';
import { Upload, UploadProps } from 'antd';
import ImageResizer from 'react-image-file-resizer';

export const EditVenue: React.FC<IEditVenueProps> = (props) => {
  let navigate = useNavigate();
  const [confirmAlert, setConfirmAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    message: '',
    alert: false,
  });
  const [warning, setWarning] = useState({
    message: '',
    alert: false,
  });
  const [success, setSuccess] = useState({
    message: '',
    alert: false,
  });
  const [venue, setVenue] = useState({
    name: '',
    description: '',
    address: '',
    city: '',
    state: '',
    country: '',
    zipcode: '',
    polygon_points: [] as { lat: number; lng: number }[],
    location_point: { lat: 0, lng: 0 },
    asset: [] as any[],
    buildings: [] as any[],
    image: '',
  });
  const [isDrawActive, setIsDrawActive] = useState(false);
  const [boundaryConfirmed, setBoundaryConfirmed] = useState(false);
  const [assetBuildingConfimrationModal, setAssetBuildingConfimrationModal] = useState({ alert: false, message: '' });
  const [assetBuildingToRemove, setAssetBuildingToRemove] = useState(false);
  const [outsideAssets, setOutsideAssets] = useState<any[]>([]);
  const [outsideBuildings, setOutsideBuildings] = useState<any[]>([]);
  const [changedBoundary, setChangedBoundary] = useState([] as { lat: number; lng: number }[]);
  const [imageUploaded, setImageUploaded] = useState(false);

  useEffect(() => {
    getVenue();
  }, []);

  useEffect(() => {
    setVenue((prevValues: any) => {
      return {
        ...prevValues,
        latitude: parseFloat(props.position.lat.toFixed(6)),
        longitude: parseFloat(props.position.lng.toFixed(6)),
      };
    });
  }, [props.position]);

  useEffect(() => {
    if (props.boundaryPolygon && props.boundaryPolygon.length === 0) return;
    if (boundaryConfirmed) {
      setVenue((prevValues: any) => {
        return {
          ...prevValues,
          polygon_points: props.boundaryPolygon?.map((point) => ({
            lat: parseFloat(point.lat().toFixed(6)),
            lng: parseFloat(point.lng().toFixed(6)),
          })),
        };
      });
    }
  }, [props.boundaryPolygon, boundaryConfirmed]);

  const handleInputChange = (e: any) => {
    setVenue((prevValues: any) => {
      return { ...prevValues, [e.target.name]: e.target.value };
    });
  };

  const getVenue = () => {
    setLoading(true);
    ApiHandler({ apiName: 'getVenue', body: {}, params: { venue_id: props.venueId } })
      .then((response) => {
        setLoading(false);
        setVenue(response.data);
      })
      .catch((error) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error.data.message, alert: true });
        }
      });
  };

  const validateRequest = () => {
    if (venue.name.trim() === '') {
      setWarning({ message: 'Venue name is required', alert: true });
      return false;
    }
    return true;
  };

  const checkAssetsBuildingsInVenue = () => {
    console.log('Checking assets/buildings in venue…');
    // const polygon = venue.polygon_points;
    const assets = venue.asset || [];
    const buildings = venue.buildings || [];

    const newBoundary =
      props.boundaryPolygon?.map((p) => ({
        lat: parseFloat(p.lat().toFixed(6)),
        lng: parseFloat(p.lng().toFixed(6)),
      })) || [];

    const googlePolygon = new google.maps.Polygon({ paths: newBoundary });

    const filteredAssets = assets.filter((asset) => {
      const point = new google.maps.LatLng(asset.location.lat, asset.location.lng);
      return !google.maps.geometry.poly.containsLocation(point, googlePolygon);
    });

    setOutsideAssets(filteredAssets);

    const filteredBuildings = buildings.filter((building) => {
      const point = new google.maps.LatLng(building.location.lat, building.location.lng);
      return !google.maps.geometry.poly.containsLocation(point, googlePolygon);
    });

    setOutsideBuildings(filteredBuildings);

    let deleteMessage = '';

    if (filteredAssets.length > 0) {
      deleteMessage += `
      <span>Following assets are outside the venue:</span><br/><br/>
      <ul>
        ${filteredAssets.map((a) => `<li>${a.tracking_id}</li>`).join('')}
      </ul>
      <i>On confirming, these assets will <b>be dissociated from the Venue</b>.</i>
      <br/><br/>
    `;
    }

    if (filteredBuildings.length > 0) {
      deleteMessage += `
      <span>Following buildings are outside the venue:</span><br/><br/>
      <ul>
        ${filteredBuildings.map((b) => `<li>${b.name}</li>`).join('')}
      </ul>
      <i>On confirming, these buildings will <b>be dissociated from the Venue</b>.</i>
      <br/><br/>
    `;
    }

    if (filteredAssets.length === 0 && filteredBuildings.length === 0) {
      console.log('No assets/buildings outside venue, proceeding to update venue');
      setBoundaryConfirmed(true);
      setIsDrawActive(false);
      props.setBoundaryDrawMode(null);
      return;
    }

    deleteMessage += `Do you want to proceed?`;

    setAssetBuildingConfimrationModal({
      alert: true,
      message: deleteMessage,
    });
  };

  const removeAssetsVenue = () => {
    setLoading(true);
    const requestBody: any = { asset_ids: [] };
    outsideAssets.forEach((asset: any) => {
      requestBody.asset_ids.push(asset.id);
    });
    ApiHandler({ apiName: 'removeAssetFromVenue', body: requestBody, params: {} })
      .then((response: any) => {
        setLoading(false);
        removeBuildingsVenue();
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error.data.message, alert: true });
        }
      });
  };

  const removeBuildingsVenue = () => {
    setLoading(true);
    const requestBody: any = { building_ids: [] };
    outsideBuildings.forEach((building: any) => {
      requestBody.building_ids.push(building.id);
    });
    ApiHandler({ apiName: 'removeBuildingFromVenue', body: requestBody, params: {} })
      .then((response: any) => {
        setLoading(false);
        updateVenue();
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error.data.message, alert: true });
        }
      });
  };

  const updateVenue = () => {
    if (!validateRequest()) return;
    setLoading(true);
    venue.polygon_points.push(venue.polygon_points[0]);

    const updatedVenue = {
      name: venue.name,
      description: venue.description,
      address: venue.address,
      city: venue.city,
      state: venue.state,
      country: venue.country,
      zipcode: venue.zipcode,
      boundary_plot: venue.polygon_points,
      latitude: venue.location_point.lat,
      longitude: venue.location_point.lng,
    };
    ApiHandler({ apiName: 'updateVenue', body: updatedVenue, params: { venue_id: props.venueId } })
      .then((response) => {
        setLoading(false);
        setSuccess({ message: 'Venue Updated Successfully', alert: true });
        setTimeout(() => {
          props.navigateTo('venueDetails');
        }, 1500);
      })
      .catch((error) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error.data.message, alert: true });
        }
      });
  };

  const confirmBoundary = () => {
    console.log('Confirming boundary…');
    // setBoundaryConfirmed(true);
    if (venue.asset.length > 0 || venue.buildings.length > 0) {
      console.log('Checking assets/buildings in venue on boundary confirm ');
      // setBoundaryConfirmed(true);
      checkAssetsBuildingsInVenue();
      console.log('After checkAssetsBuildingsInVenue call in confirmBoundary');
      // if (assetBuildingToRemove) {
      //   console.log('Confirmed boundary with asset/building removal');
      //   setBoundaryConfirmed(true);
      //   setIsDrawActive(false);
      //   props.setBoundaryDrawMode(null);
      // }
    } else {
      console.log('No assets/buildings to check on boundary confirm');
      setBoundaryConfirmed(true);
      setIsDrawActive(false);
      props.setBoundaryDrawMode(null);
    }
  };

  const drawBoundary = () => {
    setIsDrawActive(true);
    props.setBoundaryDrawMode('draw');
    props.setHiddenVenueId(props.venueId);
    if (!boundaryConfirmed) {
      props.setVenueBoundaryPath(venue.polygon_points.map((point) => new google.maps.LatLng(point.lat, point.lng)));
    }
    // setBoundaryConfirmed(false);
  };

  const propsDragger: UploadProps = {
    name: 'file',
    multiple: false,
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
    accept: 'image/png, image/jpeg',

    beforeUpload: (file) => {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isImage) {
        setWarning({ message: 'You can only upload JPG/PNG file!', alert: true });
        return Upload.LIST_IGNORE;
      }

      const isLt4M = file.size / 1024 / 1024 < 4;
      if (!isLt4M) {
        setWarning({ message: 'Image must be smaller than 4MB!', alert: true });
        return Upload.LIST_IGNORE;
      }
      ImageResizer.imageFileResizer(
        file,
        800,
        800,
        'JPEG',
        100,
        0,
        (uri: any) => {
          setImageUploaded(true);
          setVenue((prev) => ({ ...prev, image: uri }));
        },
        'base64'
      );

      return false;
    },
  };

  return (
    <div className="h-100 overflow-auto">
      <div className="app-card position-relative app-card-size right">
        <div className="row-wise vertical-center space-between px-4 py-2">
          <span className="app-card-action-heading fw-bold">Update Venue</span>
          <div
            onClick={() => {
              props.setVenueBoundaryPath([]);
              props.setHiddenVenueId('');
              props.navigateTo('venueDetails');
            }}>
            <CloseOutlined className="fs-6 cursor-pointer" />
          </div>
        </div>
        <div className="border-bottom" />
        <div className="overflow-auto">
          <div className="border-bottom mx-4" />
          <div className="px-4 py-2">
            {imageUploaded ? (
              <div className="vertical-center center my-3 position-relative">
                <DeleteTwoTone
                  className="position-absolute z-index-10"
                  onClick={() => {
                    const venueTemp: any = venue;
                    venueTemp['image'] = '';
                    setVenue(venueTemp);
                    setImageUploaded(false);
                  }}
                />
                <img src={venue.image} height={'auto'} width={350 - 48} />
              </div>
            ) : (
              <div className="drop-height">
                <Dragger {...propsDragger}>
                  <p className="ant-upload-drag-icon">
                    <FileImageOutlined />
                  </p>
                  <p className="ant-upload-text upload-text">Click or drag file to this area to upload</p>
                  <p className="ant-upload-hint upload-text-sub">Pick a photo up to 4MB.</p>
                </Dragger>
              </div>
            )}
            <div className="fw-semibold small text-muted mb-2 mt-2">Venue Boundaries</div>
            {isDrawActive ? (
              <div className="row">
                <div className="col-6">
                  <SecondaryButton className="my-1 h-btn-lg" label={'Confirm Boundary'} clicked={confirmBoundary} disable={false} />
                </div>
                <div className="col-6">
                  <SecondaryButton
                    className="my-1 h-btn-lg"
                    label={'Cancel'}
                    clicked={() => {
                      if (!boundaryConfirmed) {
                        console.log('not confirmed, reverting');
                        props.setVenueBoundaryPath([]);
                        props.setHiddenVenueId('');
                      }
                      setIsDrawActive(false);
                      props.setBoundaryDrawMode(null);
                    }}
                    disable={false}
                    type="delete"
                  />
                </div>
              </div>
            ) : (
              <div className="w-100">
                <SecondaryButton
                  className="mb-2 mt-2"
                  label={'Edit boundaries'}
                  clicked={drawBoundary}
                  disable={false}
                  icon={<PenIcon style={{ color: '#1677FF' }} />}
                />
              </div>
            )}
            <form className="col-wise h-100 pb-1 mb-1 pt-2">
              <LabelledInputNew
                title="Name *"
                name="name"
                onChange={(e: any) => {
                  handleInputChange(e);
                }}
                value={venue.name}
                placeholder="Enter name"
                titleClassName="fw-semibold small text-muted"
                textColorRequired={false}
              />
              <div className="mb-2">
                <span className="d-block mb-2 fw-semibold small text-muted">Description</span>
                <textarea
                  rows={5}
                  id="description"
                  className="w-100 textbox-box input-text h-auto p-2"
                  placeholder="Enter description"
                  name="description"
                  onChange={(e: any) => {
                    handleInputChange(e);
                  }}
                  value={venue.description}></textarea>
              </div>

              <div className="mb-2">
                <span className="d-block mb-2 fw-semibold small text-muted">Street Address</span>
                <textarea
                  rows={2}
                  id="address"
                  className="w-100 textbox-box input-text h-auto p-2"
                  placeholder="Enter street address"
                  name="address"
                  onChange={(e: any) => {
                    handleInputChange(e);
                  }}
                  value={venue.address}></textarea>
              </div>

              <div className="row gx-2 mt-1">
                <div className="col-6">
                  <LabelledInputNew
                    title="City"
                    name="city"
                    onChange={(e: any) => {
                      handleInputChange(e);
                    }}
                    value={venue.city}
                    placeholder="Enter City"
                    titleClassName="fw-semibold small text-muted"
                    textColorRequired={false}
                  />
                </div>
                <div className="col-6">
                  <LabelledInputNew
                    title="State"
                    name="state"
                    onChange={(e: any) => {
                      handleInputChange(e);
                    }}
                    value={venue.state}
                    placeholder="Enter State"
                    titleClassName="fw-semibold small text-muted"
                    textColorRequired={false}
                  />
                </div>
              </div>

              <div className="row gx-2">
                <div className="col-6">
                  <LabelledInputNew
                    title="Country"
                    name="country"
                    onChange={(e: any) => {
                      handleInputChange(e);
                    }}
                    value={venue.country}
                    placeholder="Enter Country"
                    titleClassName="fw-semibold small text-muted"
                    textColorRequired={false}
                  />
                </div>
                <div className="col-6">
                  <LabelledInputNew
                    title="Zip Code"
                    name="zipcode"
                    onChange={(e: any) => {
                      handleInputChange(e);
                    }}
                    value={venue.zipcode}
                    placeholder="Enter ZIP"
                    titleClassName="fw-semibold small text-muted"
                    textColorRequired={false}
                  />
                </div>
              </div>

              <div className="row g-2 mb-3 mt-2">
                <div className="col-6">
                  <div className="rounded p-2" style={{ backgroundColor: '#e4f1f4' }}>
                    <span className="d-block mb-1 fw-semibold small text-muted">Latitude</span>
                    <span className="d-block fw-bold text-dark">{venue.location_point.lat?.toFixed(6) || '0.000000'}</span>
                  </div>
                </div>
                <div className="col-6">
                  <div className="rounded p-2" style={{ backgroundColor: '#e4f1f4' }}>
                    <span className="d-block mb-1 fw-semibold small text-muted">Longitude</span>
                    <span className="d-block fw-bold text-dark">{venue.location_point.lng?.toFixed(6) || '0.000000'}</span>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div style={{ marginTop: 'auto' }} className="px-4 py-2">
          <PrimaryButton
            className="w-100"
            label="Save Changes"
            clicked={() => {
              if (!validateRequest()) return;
              // setConfirmAlert(true);
              if ((venue.asset.length > 0 || venue.buildings.length > 0) && assetBuildingToRemove) {
                removeAssetsVenue();
              } else {
                console.log('No assets/buildings to check on save changes');
                updateVenue();
              }
              // (venue.asset.length > 0 || venue.buildings.length > 0) ? checkAssetsBuildingsInVenue() : updateVenue();
            }}
          />
        </div>
      </div>

      <Spinner show={loading} />

      <ConfirmAlert
        message={`Do you confirm the changes in the venue?`}
        primaryText={'Yes'}
        secondaryText={'No'}
        secondaryAction={() => {
          setConfirmAlert(false);
        }}
        visible={confirmAlert}
        title={` Confirm Changes `}
        primaryAction={() => {
          setConfirmAlert(false);
          updateVenue();
        }}
        onClose={() => {
          setConfirmAlert(false);
        }}
      />

      <ErrorAlert
        show={error.alert}
        onDismiss={() => {
          setError({ message: '', alert: false });
        }}
        message={error.message}
      />
      <SuccessAlert
        show={success.alert}
        onDismiss={() => {
          setSuccess({ message: '', alert: false });
        }}
        message={success.message}
      />
      <WarningAlert
        show={warning.alert}
        onDismiss={() => {
          setWarning({ message: '', alert: false });
        }}
        message={warning.message}
      />

      <ConfirmAlert
        message={assetBuildingConfimrationModal.message}
        primaryText={'Yes'}
        secondaryText={'No'}
        secondaryAction={() => {
          setAssetBuildingConfimrationModal({ alert: false, message: '' });
          setAssetBuildingToRemove(false);
          props.setVenueBoundaryPath(venue.polygon_points.map((point) => new google.maps.LatLng(point.lat, point.lng)));
        }}
        visible={assetBuildingConfimrationModal.alert}
        title={` Confirm Boundary `}
        primaryAction={() => {
          setAssetBuildingConfimrationModal({ alert: false, message: '' });
          setBoundaryConfirmed(true);
          setIsDrawActive(false);
          props.setBoundaryDrawMode(null);
          setAssetBuildingToRemove(true);
          // outsideAssets?.length !== 0 ? removeAssetsVenue() : deleteVenue();
        }}
        onClose={() => {
          setAssetBuildingConfimrationModal({ alert: false, message: '' });
        }}
      />
    </div>
  );
};
